/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
var sections = window.theme.sections;
var slideshowAutoExtension = {
  init: function() {
    this.on('slideshow_desktop_init_done', this._autoplaySlideshow.bind(this));
  },
  _autoplaySlideshow: setInterval(function() {
    var $slide = $('.slideshow__slide--active')
                   .removeClass('slideshow__slide--active');

    var $button = $('.slideshow__button--active')
                   .removeClass('slideshow__button--active');

    var $slides = $('.slideshow__slide');

    var currentIndex = ($slides.index($slide) + 1) % $slides.length;

    $slides
      .eq(currentIndex)
      .addClass('slideshow__slide--active');

    var $buttons = $('.slideshow__button')
      .eq(currentIndex)
      .addClass('slideshow__button--active');

  }, 6000)

};

sections.extend('slideshow', slideshowAutoExtension);




//faq dropdown


jQuery('document').ready(function($) {
        
  $(".swatch-element").click(function (event) {
      event.preventDefault();
      console.log("test from 1");

      if(!$(this).hasClass("soldout")){

        //making pills highlight on click
        // Find the radio input inside the clicked swatch-element
        var radioInput = $(this).find(".itg-swatch-select");
  
        // Check if the radio input is already checked
        if (!radioInput.prop("checked")) {
            // Uncheck all radio inputs with the same name (assuming they have the same name)
            $('input[name="' + radioInput.attr("name") + '"]').prop("checked", false);
  
            // Check the radio input inside the clicked swatch-element
            radioInput.prop("checked", true);
        }
        // $(this).find(".itg-swatch-select").addClass("checked");
  
  
        //cchanging select option in hidden slect
        var inputElement = $(this).find(".itg-swatch-select");
        // Get the value of the data-variant-id attribute
        var variantId = inputElement.data("variant-id");
        // Find the corresponding option in the product-form__master-select select element
        var selectElement = $(".product-form__master-select");
        var optionToSelect = selectElement.find('option[value="' + variantId + '"]');
  
        // Remove the "selected" attribute from all options
        selectElement.find('option').removeAttr("selected");
  
        // Find the option with the matching value and add the "selected" attribute
        selectElement.find('option[value="' + variantId + '"]').attr("selected", true);
  
  
  
        //changing product image on variant change
        var clicked_imageid = inputElement.data("imageid");
        $(".itg_product").addClass("hide");
        var productElement = $('.itg_product[data-id="' + clicked_imageid + '"]');
        productElement.removeClass("hide");
      }
  });



  //final sale checkbox fuunctionality
  $('#final_sale_checkbox').change(function(){
    if($(this).is(":checked")) {
        $(".hide_final_sale").slideDown();
    } else {
        $(".hide_final_sale").slideUp();
    }
  });

  //HREF CLICK//
  $(document).on("click", ".href_click", function () {
    // Get the value of data-href attribute
    var url = $(this).data("href");
    if (url) {
      if($(this).hasClass("new_tab")){
        window.open(url, '_blank');
      }else{
        window.location.href = url;
      }
    }
  });
  //HREF CLICK//

});

//promo badge visibility
jQuery(document).ready(function($) {
  function checkScroll() {
      // Get how much the page is scrolled vertically
      var scrollTop = $(window).scrollTop();

      // If scrolled more than 10px, show the badge
      if(scrollTop > 210){
          $('.scroll_show_hide').addClass('visible');
      } else {
          $('.scroll_show_hide').removeClass('visible');
      }
  }

  // Check on page scroll
  $(window).on('scroll', checkScroll);

    // Check on keydown (arrow down/up keys)
    $(document).on('keydown', function(e){
        // Arrow down or page down
        if(e.key === "ArrowDown" || e.key === "PageDown") {
            $('.scroll_show_hide').addClass('visible');
        }
        // Arrow up or page up
        if(e.key === "ArrowUp" || e.key === "PageUp") {
            $('.scroll_show_hide').removeClass('visible');
        }
    });
});
//promo badge visibility